export const packages = [
  {
    id: 1,
    name: "Basic",
    price: "₹1,900 per sqft",
    description: "Essential construction with quality materials and standard finishes",
    features: [
      "3D Elevation & Architectural 2D Layout",
      "Electrical, Plumbing & Structural Design",
      "10 ft Floor-to-Floor Height",
      "Ceramic Tiles up to ₹40/sqft",
      "Aluminum Windows ₹440/sqft (Jindal)",
      "MS Railing Staircase",
      "1000 Ltr OHT + 4000 Ltr Sump"
    ],
    isSignature: false,
    details: [
      {
        title: "Structure",
        items: [
          { label: "Steel", value: "Sunvik / Prime gold / Kamdhenu / Sk Indus" },
          { label: "Cement", value: "Zuari / Dalmia / Bharathi" },
          { label: "Aggregates", value: "Bangalore (20mm & 40mm)" },
          { label: "Block Work", value: '6" outer, 4" inner - Solid Concrete Blocks' },
          { label: "RCC Mix", value: "Manual Mix" },
          { label: "Ceiling Height", value: "10 ft (Floor-to-Floor)" }
        ]
      },
      {
        title: "Kitchen",
        items: [
          { label: "Ceramic Tiles", value: "Upto ₹40/sqft" },
          { label: "Sink", value: "Upto ₹3,000 (Single Bowl SS)" },
          { label: "Sink Faucet", value: "Upto ₹1,300" },
          { label: "Sink Accessories", value: "ISI Marked" }
        ]
      },
      {
        title: "Bathroom",
        items: [
          { label: "Wall Dado", value: "Upto ₹40/sqft (7 Feet)" },
          { label: "Sanitary & CP Fittings", value: "Upto ₹30,000/1000 sqft (Cera)" },
          { label: "CPVC Pipe", value: "APL Apollo" },
          { label: "Bathroom Doors", value: "Waterproof Flush Doors or WPC" },
          { label: "Solar Water Heater", value: "—" }
        ]
      },
      {
        title: "Doors & Windows",
        items: [
          { label: "Main Door", value: "Flush Door with Veneer & Salwood Frame (Upto ₹20,000)" },
          { label: "Internal Doors", value: "Membrane / Flush Door with Laminate (Upto ₹11,000)" },
          { label: "Puja Room Door", value: "Teak Shutter with Teak Frame (₹28,000 per 2000 sqft)" },
          { label: "Windows", value: "Aluminium ₹440/sqft (Jindal Profiles)" },
          { label: "Window Grills", value: "Basic MS Grill ₹195/sqft" }
        ]
      },
      {
        title: "Plastering",
        items: [
          { label: "Ceiling (12mm)", value: "C:M 1:4" },
          { label: "Internal Walls (15mm)", value: "C:M 1:4" },
          { label: "External Walls (20mm)", value: "C:M 1:6" }
        ]
      },
      {
        title: "Painting",
        items: [
          { label: "Interior", value: "JK Putty + Primer + Tractor Emulsion (Asian)" },
          { label: "Exterior", value: "Primer + Ace Exterior Emulsion (Asian)" }
        ]
      },
      {
        title: "Flooring",
        items: [
          { label: "Living & Dining", value: "Tiles Upto ₹50/sqft" },
          { label: "Rooms & Kitchen", value: "Tiles Upto ₹50/sqft" },
          { label: "Balcony & Open Area", value: "Tiles Upto ₹40/sqft" },
          { label: "Staircase", value: "Upto ₹70/sqft" },
          { label: "Parking", value: "Tiles Upto ₹40/sqft" }
        ]
      },
      {
        title: "Wiring",
        items: [
          { label: "Fireproof Wiring", value: "Finolex Silver FR" },
          { label: "Switches", value: "Legrand Allzy / GM(G9) / HI-FI / Great White" },
          { label: "Sockets", value: "Legrand Allzy / GM(G9) / HI-FI / Great White" },
          { label: "UPS Provision", value: "✓ Provided" },
          { label: "EV Charging Point", value: "—" }
        ]
      },
      {
        title: "Others",
        items: [
          { label: "Overhead Tank", value: "1000 Ltrs" },
          { label: "Underground Sump", value: "4000 Ltrs" },
          { label: "Staircase Railing", value: "MS Railing" },
          { label: "Copper Gas Connection", value: "1 no. per 1500 sqft" },
          { label: "Note", value: "All fixtures (lights, fans, curtains, geyser, UPS, water purifier, solar heater, motor) to be provided by owner" }
        ]
      }
    ]
  },
  {
    id: 2,
    name: "Classic",
    price: "₹2,150 per sqft",
    description: "Enhanced construction with premium finishes and better specifications",
    features: [
      "3D Elevation & Architectural 2D Layout",
      "Electrical, Plumbing & Structural Design",
      "10 ft Floor-to-Floor Height",
      "Granite/Tiles Flooring up to ₹80/sqft",
      "UPVC Windows ₹495/sqft (Luftung/Plastone)",
      "Sanitary Fittings up to ₹50,000 (Hindware)",
      "1000 Ltr OHT + 6000 Ltr Sump"
    ],
    isSignature: false,
    details: [
      {
        title: "Structure",
        items: [
          { label: "Steel", value: "Kamdhenu / Bhuwalka / Sk Indus" },
          { label: "Cement", value: "Zuari / Dalmia / Bharathi" },
          { label: "Aggregates", value: "Bangalore (20mm & 40mm)" },
          { label: "Block Work", value: '6" outer, 4" inner - Solid Concrete Blocks' },
          { label: "RCC Mix", value: "Manual Mix" },
          { label: "Ceiling Height", value: "10 ft (Floor-to-Floor)" }
        ]
      },
      {
        title: "Kitchen",
        items: [
          { label: "Ceramic Tiles", value: "Upto ₹50/sqft" },
          { label: "Sink", value: "Upto ₹6,000 (Futura, Carysil)" },
          { label: "Sink Faucet", value: "Upto ₹2,600" },
          { label: "Sink Accessories", value: "ISI Marked" }
        ]
      },
      {
        title: "Bathroom",
        items: [
          { label: "Wall Dado", value: "Upto ₹50/sqft (7 Feet)" },
          { label: "Sanitary & CP Fittings", value: "Upto ₹50,000/1000 sqft (Hindware / Parryware)" },
          { label: "CPVC Pipe", value: "APL Apollo" },
          { label: "Bathroom Doors", value: "Waterproof Flush Doors or WPC" },
          { label: "Bathroom Accessories", value: "Mirror, Soap Dish, Towel Rail (₹7,000/1000 sqft)" },
          { label: "Solar Water Heater", value: "Provision Only" }
        ]
      },
      {
        title: "Doors & Windows",
        items: [
          { label: "Main Door", value: 'Teak Door with Teak Frame 5"x3" (Upto ₹30,000)' },
          { label: "Internal Doors", value: "Membrane / Flush Door with Laminate (Upto ₹11,000)" },
          { label: "Puja Room Door", value: "Teak Shutter with Teak Frame (₹28,000 per 2000 sqft)" },
          { label: "Windows", value: "UPVC ₹495/sqft (Luftung / Plastone / Lesso)" },
          { label: "Window Grills", value: "Basic MS Grill ₹195/sqft" }
        ]
      },
      {
        title: "Plastering",
        items: [
          { label: "Ceiling (12mm)", value: "C:M 1:4" },
          { label: "Internal Walls (15mm)", value: "C:M 1:4" },
          { label: "External Walls (20mm)", value: "C:M 1:6" }
        ]
      },
      {
        title: "Painting",
        items: [
          { label: "Interior", value: "JK Putty + Primer + Tractor Shyne Emulsion (Asian)" },
          { label: "Exterior", value: "Primer + Apex Exterior Emulsion (Asian)" }
        ]
      },
      {
        title: "Flooring",
        items: [
          { label: "Living & Dining", value: "Tiles / Granite Upto ₹80/sqft" },
          { label: "Rooms & Kitchen", value: "Tiles Upto ₹60/sqft" },
          { label: "Balcony & Open Area", value: "Tiles Upto ₹60/sqft (Anti Skid)" },
          { label: "Staircase", value: "Upto ₹80/sqft (Granite)" },
          { label: "Parking", value: "Tiles Upto ₹50/sqft (Anti Skid)" }
        ]
      },
      {
        title: "Wiring",
        items: [
          { label: "Fireproof Wiring", value: "Finolex / Anchor / Havells" },
          { label: "Switches", value: "Roma / Lisha / Legrand Lyncus / Havells Fabio" },
          { label: "Sockets", value: "Roma / Lisha / Legrand Lyncus / Havells Fabio" },
          { label: "UPS Provision", value: "✓ Provided" },
          { label: "EV Charging Point", value: "—" }
        ]
      },
      {
        title: "Others",
        items: [
          { label: "Overhead Tank", value: "1000 Ltrs" },
          { label: "Underground Sump", value: "6000 Ltrs" },
          { label: "Staircase Railing", value: "MS Railing" },
          { label: "Copper Gas Connection", value: "1 no. per 1500 sqft" },
          { label: "Note", value: "All fixtures (lights, fans, curtains, geyser, UPS, water purifier, solar heater, motor) to be provided by owner" }
        ]
      }
    ]
  },
  {
    id: 3,
    name: "Premium",
    price: "₹2,550 per sqft",
    description: "Superior construction with luxury finishes and extended specifications",
    features: [
      "3D Elevation & Architectural 2D Layout",
      "Electrical, Plumbing & Structural Design",
      `10'6" ft Floor-to-Floor Height`,
      "Granite/Tiles Flooring up to ₹110/sqft",
      "UPVC Windows ₹550/sqft (NCL Veka)",
      "Sanitary Fittings up to ₹70,000 (Jaquar)",
      "1500 Ltr OHT + 8000 Ltr Sump"
    ],
    isSignature: true,
    badge: "BEST VALUE",
    details: [
      {
        title: "Structure",
        items: [
          { label: "Steel", value: "Jindal Panter / Vizag Indus" },
          { label: "Cement", value: "ACC / Ultratech / Ramco Supercrete" },
          { label: "Aggregates", value: "Bangalore (20mm & 40mm)" },
          { label: "Block Work", value: '6" outer, 4" inner - Solid Concrete Blocks' },
          { label: "RCC Mix", value: "Manual Mix / Locally Available RMC near Site (With Test Reports)" },
          { label: "Ceiling Height", value: `10'6" ft (Floor-to-Floor)` }
        ]
      },
      {
        title: "Kitchen",
        items: [
          { label: "Ceramic Tiles", value: "Upto ₹60/sqft" },
          { label: "Sink", value: "Upto ₹8,000 (Futura, Carysil)" },
          { label: "Sink Faucet", value: "Upto ₹3,500" },
          { label: "Sink Accessories", value: "Parryware / Hindware / Jaquar" }
        ]
      },
      {
        title: "Bathroom",
        items: [
          { label: "Wall Dado", value: "Upto ₹60/sqft (10 Feet)" },
          { label: "Sanitary & CP Fittings", value: "Upto ₹70,000/1000 sqft (Jaquar)" },
          { label: "CPVC Pipe", value: "Ashirvad / Prince" },
          { label: "Bathroom Doors", value: "Waterproof Flush Doors or WPC" },
          { label: "Bathroom Accessories", value: "Mirror, Soap Dish, Towel Rail (₹9,000/1000 sqft)" },
          { label: "Solar Water Heater", value: "200 Ltr Solar (Included)" }
        ]
      },
      {
        title: "Doors & Windows",
        items: [
          { label: "Main Door", value: 'Teak Door with Teak Frame 5"x3.5" (Upto ₹40,000)' },
          { label: "Internal Doors", value: "Membrane / Flush Door with Laminate (Upto ₹13,000)" },
          { label: "Puja Room Door", value: "Teak Shutter with Teak Frame (₹28,000 per 2000 sqft)" },
          { label: "Windows", value: "UPVC ₹550/sqft (NCL Veka / Prominance / V-tech / Greentech)" },
          { label: "Window Grills", value: "Basic MS Grill ₹195/sqft" }
        ]
      },
      {
        title: "Plastering",
        items: [
          { label: "Ceiling (12mm)", value: "C:M 1:4" },
          { label: "Internal Walls (15mm)", value: "C:M 1:4" },
          { label: "External Walls (20mm)", value: "C:M 1:6" }
        ]
      },
      {
        title: "Painting",
        items: [
          { label: "Interior", value: "JK Putty + Primer + Apcolite Premium Emulsion (Asian)" },
          { label: "Exterior", value: "Primer + Apex Exterior Emulsion (Asian)" }
        ]
      },
      {
        title: "Flooring",
        items: [
          { label: "Living & Dining", value: "Tiles / Granite Upto ₹110/sqft (Laying Extra)" },
          { label: "Rooms & Kitchen", value: "Tiles Upto ₹65/sqft" },
          { label: "Balcony & Open Area", value: "Tiles Upto ₹80/sqft (Anti Skid)" },
          { label: "Staircase", value: "Upto ₹110/sqft" },
          { label: "Parking", value: "Tiles Upto ₹60/sqft (Anti Skid)" }
        ]
      },
      {
        title: "Wiring",
        items: [
          { label: "Fireproof Wiring", value: "Finolex / Anchor / Havells" },
          { label: "Switches", value: "Legrand Mylinc / Havells Coral / Roma" },
          { label: "Sockets", value: "Legrand Mylinc / Havells Coral / Roma" },
          { label: "UPS Provision", value: "✓ Provided" },
          { label: "EV Charging Point", value: "✓ Provided (Ground Floor)" }
        ]
      },
      {
        title: "Others",
        items: [
          { label: "Overhead Tank", value: "1500 Ltrs" },
          { label: "Underground Sump", value: "8000 Ltrs" },
          { label: "Staircase Railing", value: "SS 304 Grade Railing" },
          { label: "Copper Gas Connection", value: "1 no. per 1500 sqft" },
          { label: "Note", value: "All fixtures (lights, fans, curtains, geyser, UPS, water purifier, solar heater, motor) to be provided by owner" }
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Royale",
    price: "₹2,885 per sqft",
    description: "Ultimate construction with imported finishes and comprehensive features",
    features: [
      "11 ft Floor-to-Floor Height",
      "Granite/Marble Flooring up to ₹120/sqft",
      "UPVC/Aluminum Windows ₹700/sqft",
      "Sanitary Fittings up to ₹80,000 (Kohler)",
      "SS 304 Glass Railing Staircase",
      "2000 Ltr OHT + 10000 Ltr Sump",
      "200 Ltr Solar Water Heater",
      "EV Charging Point"
    ],
    isSignature: false,
    details: [
      {
        title: "Structure",
        items: [
          { label: "Steel", value: "Jindal Panter / JSW / Tata (Fe 550/Fe 550D)" },
          { label: "Cement", value: "ACC / Ultratech / Ramco Supercrete (43G Surface, 53G Core)" },
          { label: "Aggregates", value: "Bangalore (20mm & 40mm)" },
          { label: "Block Work", value: '6" outer, 4" inner - Solid Concrete Blocks' },
          { label: "RCC Mix", value: "Manual Mix / RMC near Site (M20 or M25)" },
          { label: "Ceiling Height", value: "11 ft (Floor-to-Floor)" }
        ]
      },
      {
        title: "Kitchen",
        items: [
          { label: "Ceramic Tiles", value: "Upto ₹65/sqft" },
          { label: "Sink", value: "Upto ₹8,000 (Futura, Carysil)" },
          { label: "Sink Faucet", value: "Upto ₹3,500" },
          { label: "Sink Accessories", value: "Parryware / Hindware / Jaquar" }
        ]
      },
      {
        title: "Bathroom",
        items: [
          { label: "Wall Dado", value: "Upto ₹65/sqft (10 Feet)" },
          { label: "Sanitary & CP Fittings", value: "Upto ₹80,000/1000 sqft (Kohler)" },
          { label: "CPVC Pipe", value: "Ashirvad / Prince" },
          { label: "Bathroom Doors", value: "Waterproof Flush Doors or WPC" },
          { label: "Bathroom Accessories", value: "Mirror, Soap Dish, Towel Rail" },
          { label: "Solar Water Heater", value: "200 Ltr Solar (Included)" }
        ]
      },
      {
        title: "Doors & Windows",
        items: [
          { label: "Main Door", value: 'Teak Door with Teak Frame 5"x3.5" (Upto ₹50,000)' },
          { label: "Internal Doors", value: "Membrane / Flush Door with Laminate (Upto ₹15,000)" },
          { label: "Puja Room Door", value: "Teak Shutter with Teak Frame (₹32,000 per 2000 sqft)" },
          { label: "Windows", value: "UPVC/Aluminium ₹700/sqft (NCL Veka / Wintech / Teak Wood, 3 Track with 1 Mesh)" },
          { label: "Window Grills", value: "Basic MS Grill ₹195/sqft" }
        ]
      },
      {
        title: "Plastering",
        items: [
          { label: "Ceiling (12mm)", value: "C:M 1:4" },
          { label: "Internal Walls (15mm)", value: "C:M 1:4" },
          { label: "External Walls (20mm)", value: "C:M 1:6" }
        ]
      },
      {
        title: "Painting",
        items: [
          { label: "Interior", value: "JK Putty + Primer + Royale Luxury Emulsion (Asian)" },
          { label: "Exterior", value: "Primer + Apex Ultima Exterior Emulsion (Asian)" }
        ]
      },
      {
        title: "Flooring",
        items: [
          { label: "Living & Dining", value: "Tiles / Granite / Indian Marble Upto ₹120/sqft (Laying Extra)" },
          { label: "Rooms & Kitchen", value: "Tiles Upto ₹70/sqft" },
          { label: "Balcony & Open Area", value: "Tiles Upto ₹90/sqft (Anti Skid)" },
          { label: "Staircase", value: "Upto ₹140/sqft" },
          { label: "Parking", value: "Tiles Upto ₹70/sqft (Anti Skid)" }
        ]
      },
      {
        title: "Wiring",
        items: [
          { label: "Fireproof Wiring", value: "Finolex Gold / Anchor / Havells" },
          { label: "Switches", value: "Schneider Unica Pure / Legrand Myrius / Jaquar" },
          { label: "Sockets", value: "Schneider Unica Pure / Legrand Myrius / Jaquar" },
          { label: "UPS Provision", value: "✓ Provided" },
          { label: "EV Charging Point", value: "✓ Provided (Ground Floor)" }
        ]
      },
      {
        title: "Others",
        items: [
          { label: "Overhead Tank", value: "2000 Ltrs (Double Layered, Apollo)" },
          { label: "Underground Sump", value: "10000 Ltrs" },
          { label: "Staircase Railing", value: "SS 304 Grade Railing with Glass" },
          { label: "Copper Gas Connection", value: "1 no. per 1500 sqft" },
          { label: "Note", value: "All fixtures (lights, fans, curtains, geyser, UPS, water purifier, solar heater, motor) to be provided by owner" }
        ]
      }
    ]
  }
];
